// extracted by mini-css-extract-plugin
module.exports = {"form":"PayrollFBDataModal__form--9oRPe","confirm":"PayrollFBDataModal__confirm--3p1kW","notes":"PayrollFBDataModal__notes--3ehU3","wrap":"PayrollFBDataModal__wrap--2FIHU"};